module.exports = __webpack_public_path__ + "static/media/shape-blue.6423f095.svg";